class MaxHeight {

  constructor(element, diffelem) {
    this.elem = element;
    this.diffelem = diffelem;
    this.height;
    this.get();
    this.set();
  }

  get() {
    this.diffH = 0;

    let diffElemLen = this.diffelem.length;
    for (let i = 0; i < diffElemLen; i++) {
      if (this.diffelem[i] !== null) {
        this.diffH += this.diffelem[i].clientHeight;
      }
    }


    this.height = window.innerHeight - this.diffH;
  }

  set() {

    let len = this.elem.length;

    for (let i = 0; i < len; i++) {
      this.elem[i].style.height = `${this.height}px`
    }
  }

  reset() {
    this.get();
    this.set();
  }

};
